import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { CreateThirdPartyMachineRequest, CreateMachineResponse } from '../types/machine-setup-types';

export class CreateThirdPartyMachineUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(data: CreateThirdPartyMachineRequest): Promise<CreateMachineResponse> {
    return this.repository.createThirdPartyMachine(data);
  }
}
